/**
 * The two dashed arrows of the design (guide §4) are decorative connectors, not icons: 40×12 between the
 * empty-state step cards, 28×12 between source and destination in pickers. Never put text in them.
 */
export function DashedArrow({ size = "wide" }: { size?: "wide" | "narrow" }): JSX.Element {
  const width = size === "wide" ? 40 : 28;
  const line = size === "wide" ? "M0 6h34" : "M0 6h24";
  const head = size === "wide" ? "M32 2l4 4-4 4" : "M20 2l4 4-4 4";
  return (
    <svg
      className="route-arrow"
      width={width}
      height={12}
      viewBox={`0 0 ${width} 12`}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      aria-hidden="true"
    >
      <path d={line} strokeDasharray="3 4" />
      <path d={head} />
    </svg>
  );
}
